import { getOnlinePortalSubdomain, isOnlinePortalUrlSubdomainReserved } from './UrlUtils';

type BuildModernPortalApplicationUrlOptions = {
	token: string;
};

export function buildModernPortalApplicationUrl(applicationId: string | number, options: BuildModernPortalApplicationUrlOptions): string {
	const pathPrefix = isOnlinePortalUrlSubdomainReserved()
		? `/${encodeURIComponent(getOnlinePortalSubdomain())}`
		: '';

	const baseUrl = `/next${pathPrefix}/application/${applicationId}`;

	if (!options.token) {
		return baseUrl;
	}

	return `${baseUrl}?${new URLSearchParams({ token: options.token }).toString()}`;
}
